export const environment = {
    production: false,
    // If you use Angular proxy: /api -> http://localhost:3000
    apiBaseUrl: 'https://lfm-us-controlling.docker.kalayourlife.com/api/v1'
};